import PropTypes from 'prop-types';
import React from 'react';

import './skeleton.scss'

export function SkeletonButton({
  className = ''
}) {
  return (
    <div
      className={`placeholder-button placeholder-animated-background btn ${className}`}
    />);
}

SkeletonButton.propTypes = {
  className: PropTypes.string
};

export default SkeletonButton;
